import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { DialogActions, Divider } from "@mui/material";
import "../../styles/components/Editor.scss";
import "../../styles/components/Qualifiers/Qualifiers.scss";
import "../../styles/components/EditorModal.scss";
import Tooltip from "@mui/material/Tooltip";
import expiredStatus from "../../images/expired status.svg";
import available from "../../images/ApproveIcon.svg";
import claimChecked from "../../images/claims-checked.svg";

export default function QualifiersModal({
  openQualifiersModal,
  handleCloseQualifiersModal,
  modulesArrayData,
  onSelectSymbol,
  currentSymbol,
  usedSymbols,
  setusedSymbols,
  component,
  setClaimAssignClicked,
  setComponentAssignClicked,
  textSymblMapTemp,
  setTextSymblMapTemp,
  allSymbolsAssigned,
  readTextSymbolMap,
  symbolChangeTick,
  setSymbolChangeTick,
  areAllFootnotesAssigned,
  selectedClaimIndex,
  setSelectedClaimIndex,
  selectedRelatedClaimIndex,
  setSelectedRelatedClaimIndex,
  expandModule,
  setExpandModule,
}) {
  const [modulesArray, setModulesArray] = useState([]);

  useEffect(() => {
    setModulesArray(modulesArrayData || []);
  }, [modulesArrayData]);

  const [isFootnoteSelected, setIsFootnoteSelected] = useState(0);
  const footnoteSymbols = [
    "*",
    "†",
    "€",
    "¶",
    "§",
    "#",
    "@",
    "$",
    "!",
    "‡",
    "∥",
    "µ",
    "¥",
    "^",
    "~",
    "**",
    "***",
    "£",
    "▼",
    "△",
    "®",
    "ǂ",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "††",
    "‡‡",
    "§§",
    "∥∥",
  ];

  const [selectedSymbol, setSelectedSymbol] = useState(currentSymbol);
  const [hoveredSymbol, setHoveredSymbol] = useState(null);
  const [footnoteClicked, setFootnoteClicked] = useState({
    module: null,
    sub: null,
    index: null,
  });
  const [symbolsByIndex, setSymbolsByIndex] = useState({});
  const [showTickMarkByIndex, setShowTickMarkByIndex] = useState({});
  const storedSymbols = localStorage.getItem("allSymbols") || [];
  const textSymbolMap = new Map(JSON.parse(storedSymbols));

  const normalize = (t) =>
    (t || "")
      .toString()
      .trim()
      .replace(/\s+/g, " ")
      .replace(/\.$/, "")
      .toLowerCase();

  const handleSymbolClick = async (
    symbol,
    footnoteText,
    moduleIndex,
    subIndex = null
  ) => {
    if (selectedSymbol === symbol) {
      setSelectedSymbol(null);
    } else {
      setSelectedSymbol(symbol);
    }
    handleAdd(symbol, footnoteText);
  };

  function getSymbol(text) {
    return textSymbolMap?.get(text?.endsWith(".") ? text : text + ".");
  }

  function splitFootnotes(footnotesText) {
    if (!footnotesText) return [];
    return footnotesText
      .split(/(?<=\.)\s*,\s*/g)
      .map((f) => f.trim())
      .filter(Boolean);
  }

  useEffect(() => {
    if (textSymbolMap.size > 0) {
      let symbolsArray = [];
      textSymbolMap.forEach((value, key) => {
        if (
          !(value === "Not Assigned" || value === undefined || value === null)
        ) {
          symbolsArray.push(value);
        }
      });
      setusedSymbols(symbolsArray);
      setSelectedSymbol(currentSymbol);
    }

    return () => {
      setSelectedSymbol("");
    };
  }, []);

  function assignSymbol(footnoteText, symbol) {
    if (!footnoteText) return;
    textSymbolMap.set(footnoteText, symbol);

    localStorage.setItem(
      "allSymbols",
      JSON.stringify(Array.from(textSymbolMap.entries()))
    );

    window.dispatchEvent(new Event("symbolChange"));

    if (textSymbolMap.size > 0) {
      const symbolsArray = [];
      textSymbolMap.forEach((value) => {
        if (value && value !== "Not Assigned") {
          symbolsArray.push(value);
        }
      });
      setusedSymbols(symbolsArray);
    }
  }

  const handleAdd = (symbol, footnoteText) => {
    if (!symbol || !footnoteText) return;
    assignSymbol(
      footnoteText.endsWith(".") ? footnoteText : footnoteText + ".",
      symbol
    );
    onSelectSymbol(symbol, footnoteText);
  };
  const handleMouseEnter = (symbol) => {
    setHoveredSymbol(symbol);
  };

  const handleMouseLeave = () => {
    setHoveredSymbol(null);
  };
  let allUsedSymbols = usedSymbols?.filter((item) => item !== currentSymbol);

  const selectedParent =
    selectedClaimIndex != null ? modulesArray?.[selectedClaimIndex] : null;

  const selectedChild =
    selectedRelatedClaimIndex?.module != null &&
    selectedRelatedClaimIndex?.sub != null
      ? modulesArray?.[selectedRelatedClaimIndex?.module]?.relatedClaims?.[
          selectedRelatedClaimIndex?.sub
        ]
      : null;

  const selctedModuleData = selectedChild ?? selectedParent;
  useEffect(() => {
    const onSymbolChange = () => setSymbolChangeTick((p) => !p);
    window.addEventListener("symbolChange", onSymbolChange);
    return () => window.removeEventListener("symbolChange", onSymbolChange);
  }, []);

  useEffect(() => {
    if (openQualifiersModal && modulesArray?.length > 0) {
      let defaultOpenIndex;

      if (
        selectedRelatedClaimIndex.module !== null &&
        selectedRelatedClaimIndex.sub !== null
      ) {
        defaultOpenIndex = selectedRelatedClaimIndex.module;
        setSelectedClaimIndex(null);
      } else if (selectedClaimIndex !== null) {
        defaultOpenIndex = selectedClaimIndex;
        setSelectedClaimIndex(defaultOpenIndex);
      } else {
        defaultOpenIndex = 0;
      }
      setExpandModule(modulesArray.map((_, i) => i === defaultOpenIndex));
    }
  }, [openQualifiersModal, modulesArray]);

  const assignSymbolsToAllModules = () => {
    setTextSymblMapTemp(new Map(JSON.parse(storedSymbols)));
    const symbolMap = readTextSymbolMap();

    const updatedModules = (modulesArray || []).map((module) => {
      const newModule = { ...module };
      const isComponent = !!module.componentId;

      const parentFootnotes = splitFootnotes(module.footnotes);
      newModule.assignedFootnotes = parentFootnotes.map((ft) => ({
        text: ft,
        symbol: symbolMap.get(ft) || null,
      }));

      if (!isComponent) {
        newModule.assignedMatchText = {
          text: module.matchText,
          symbol: symbolMap.get(module.matchText) || null,
        };
      }

      newModule.relatedClaims = (module.relatedClaims || []).map((rel) => {
        const newRel = { ...rel };

        if (!isComponent) {
          newRel.assignedMatchText = {
            text: rel.matchText,
            symbol: symbolMap.get(rel.matchText) || null,
          };
        }

        const relFootnotes = splitFootnotes(rel.footnotes);
        newRel.assignedFootnotes = relFootnotes.map((ft) => ({
          text: ft,
          symbol: symbolMap.get(ft) || null,
        }));

        return newRel;
      });

      return newModule;
    });

    setModulesArray(updatedModules);

    if (component) {
      setComponentAssignClicked(true);
    } else {
      setClaimAssignClicked(true);
    }

    handleCloseQualifiersModal();
  };

  // useEffect(() => {
  //   try {
  //     const stored = localStorage.getItem("allSymbols") || "[]";
  //     const symbolMap = new Map(JSON.parse(stored));

  //     const ticks = {};

  //     (modulesArray || []).forEach((module, moduleIndex) => {
  //       const isComponent = !!module.componentId;
  //       const parentIgnored =
  //         module?.mlrStatus === "Expired" || module?.mustUse === false;

  //       const parentFootnotesAssigned = parentIgnored
  //         ? true
  //         : areAllFootnotesAssigned(module.footnotes, symbolMap);
  //       const activeRelated = (module.relatedClaims || []).filter(
  //         (rel) => !(rel?.mlrStatus === "Expired" || rel?.mustUse === false)
  //       );

  //       const activeRelatedValid = activeRelated.every((rel) => {
  //         const relFootnotesAssigned = areAllFootnotesAssigned(
  //           rel.footnotes,
  //           symbolMap
  //         );

  //         let relMatchAssigned = true;
  //         if (!isComponent && rel.matchText) {
  //           relMatchAssigned = areAllFootnotesAssigned(
  //             rel.matchText,
  //             symbolMap
  //           );
  //         }

  //         return isComponent
  //           ? relFootnotesAssigned
  //           : relFootnotesAssigned && relMatchAssigned;
  //       });

  //       const parentTick = parentFootnotesAssigned && activeRelatedValid;

  //       if (parentTick) {
  //         ticks[moduleIndex] = true;
  //       }

  //       (module.relatedClaims || []).forEach((rel, subIndex) => {
  //         const isExpiredOrOptional =
  //           rel?.mlrStatus === "Expired" || rel?.mustUse === false;
  //         if (isExpiredOrOptional) {
  //           return;
  //         }
  //         const relFootnotesAssigned = areAllFootnotesAssigned(
  //           rel.footnotes,
  //           symbolMap
  //         );

  //         let relMatchAssigned = true;
  //         if (!isComponent && rel.matchText) {
  //           relMatchAssigned = areAllFootnotesAssigned(
  //             rel.matchText,
  //             symbolMap
  //           );
  //         }

  //         const relTick = isComponent
  //           ? relFootnotesAssigned
  //           : relFootnotesAssigned && relMatchAssigned;

  //         if (relTick) {
  //           ticks[`${moduleIndex}-${subIndex}`] = true;
  //         }
  //       });
  //     });

  //     setShowTickMarkByIndex(ticks);
  //   } catch (err) {
  //     console.error("error while computing ticks:", err);
  //   }
  // }, [symbolChangeTick, modulesArray, areAllFootnotesAssigned]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("allSymbols") || "[]";
      const symbolMap = new Map(JSON.parse(stored));

      const ticks = {};

      (modulesArray || []).forEach((module, moduleIndex) => {
        const isComponent = !!module.componentId;

        // ✅ If parent is expired, NEVER show tick on parent
        const parentExpired = module?.mlrStatus === "Expired";

        // You can decide if optional parent should show tick or not.
        // Keeping your existing behavior: optional parent treated as "ignored" for assignment check.
        const parentOptional = module?.mustUse === false;

        // Parent footnotes condition
        const parentFootnotesAssigned = parentExpired
          ? false // ✅ expired should not pass
          : parentOptional
          ? true
          : areAllFootnotesAssigned(module.footnotes, symbolMap);

        // Related claims: ignore expired/optional related claims
        const activeRelated = (module.relatedClaims || []).filter(
          (rel) => !(rel?.mlrStatus === "Expired" || rel?.mustUse === false)
        );

        const activeRelatedValid = activeRelated.every((rel) => {
          const relFootnotesAssigned = areAllFootnotesAssigned(
            rel.footnotes,
            symbolMap
          );

          let relMatchAssigned = true;
          if (!isComponent && rel.matchText) {
            relMatchAssigned = areAllFootnotesAssigned(
              rel.matchText,
              symbolMap
            );
          }

          return isComponent
            ? relFootnotesAssigned
            : relFootnotesAssigned && relMatchAssigned;
        });

        // ✅ Parent tick: must NOT be expired
        const parentTick =
          !parentExpired && parentFootnotesAssigned && activeRelatedValid;

        if (parentTick) {
          ticks[moduleIndex] = true;
        }

        // Related claim ticks (keep your existing behavior)
        (module.relatedClaims || []).forEach((rel, subIndex) => {
          const isExpiredOrOptional =
            rel?.mlrStatus === "Expired" || rel?.mustUse === false;

          if (isExpiredOrOptional) return;

          const relFootnotesAssigned = areAllFootnotesAssigned(
            rel.footnotes,
            symbolMap
          );

          let relMatchAssigned = true;
          if (!isComponent && rel.matchText) {
            relMatchAssigned = areAllFootnotesAssigned(
              rel.matchText,
              symbolMap
            );
          }

          const relTick = isComponent
            ? relFootnotesAssigned
            : relFootnotesAssigned && relMatchAssigned;

          if (relTick) {
            ticks[`${moduleIndex}-${subIndex}`] = true;
          }
        });
      });

      setShowTickMarkByIndex(ticks);
    } catch (err) {
      console.error("error while computing ticks:", err);
      setShowTickMarkByIndex({});
    }
  }, [symbolChangeTick, modulesArray, areAllFootnotesAssigned]);

  useEffect(() => {
    if (!selctedModuleData) return;
    if (isFootnoteSelected === 1) {
      setSymbolsByIndex(selctedModuleData.matchText);
    }
  }, [isFootnoteSelected, selctedModuleData]);

  return (
    <Dialog
      open={openQualifiersModal}
      onClose={handleCloseQualifiersModal}
      className="footnote exportAsModal qualifierModal"
      aria-labelledby="form-dialog-title2">
      <DialogTitle id="customized-dialog-title2">
        <div className="baseOnModalHeadingfootnote">
          ASSIGN FOOTNOTES / CLAIM SYMBOLS
        </div>
        <br />
        <div className="footnoteNote">
          <p>
            Note: Select a claim, then assign symbols to individual footnotes.
            You can finish only after all footnotes and related claims have
            symbols.
          </p>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="row qualifierRow">
          <div className=" claimsSection customScrollBar">
            <div className="">
              {modulesArray?.map((item, index) => {
                if (item?.subType === "Image") return null;
                const expand = expandModule[index];
                const isSelected = selectedClaimIndex === index;
                return (
                  <div
                    key={index}
                    className="boldText  itemSectionClaim"
                    style={{
                      marginLeft: item?.relatedClaims?.length > 0 ? 0 : "0px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingLeft:
                          item?.relatedClaims?.length > 0 ? 0 : "19px",
                        marginLeft:
                          item?.mlrStatus === "Expired" ? "17px" : "0",
                      }}
                      onClick={() => {
                        if (item?.mlrStatus === "Expired") return;
                        setSelectedClaimIndex(index);
                        setIsFootnoteSelected(0);
                        setSelectedRelatedClaimIndex({
                          module: null,
                          sub: null,
                        });
                        setExpandModule((prev) =>
                          prev.map((expanded, i) =>
                            i === index ? !expanded : false
                          )
                        );

                        setFootnoteClicked({
                          module: null,
                          sub: null,
                          index: null,
                        });
                      }}
                      className={
                        isSelected ? "itemSectionActive" : "itemSectionInactive"
                      }
                    >
                      {item?.relatedClaims?.length > 0 &&
                        item?.mlrStatus !== "Expired" && (
                          <div className="expand-module">
                            {expand ? (
                              <p className="minusIcon22" style={{ margin: 0 }}>
                                -
                              </p>
                            ) : (
                              <p className="plusIcon22" style={{ margin: 0 }}>
                                +
                              </p>
                            )}
                          </div>
                        )}

                      <Tooltip
                        title={
                          item?.mlrStatus !== "Expired"
                            ? "Available for use"
                            : "Expired"
                        }
                        arrow
                        classes={{
                          popper: "toolTipClass2",
                          tooltip: "toolTipClass2",
                        }}
                        placement="bottom-start"
                      >
                        <span>
                          <img
                            src={
                              item?.mlrStatus !== "Expired"
                                ? available
                                : expiredStatus
                            }
                            className="img-fluid expiryIcon"
                            alt=""
                          />
                        </span>
                      </Tooltip>
                      {item.claimName || item?.componentDocNumber}
                      <div>
                        <div
                          className="parentModulebox"
                          style={{
                            backgroundColor: item.mustUse
                              ? "#E32B35"
                              : "#378A05",
                            marginLeft: "10px",
                          }}
                        ></div>
                      </div>
                      {item?.mlrStatus === "Expired" ? (
                        <Tooltip
                          title="Claim is expired, can't be used for authoring"
                          arrow
                          classes={{
                            popper: "toolTipClass",
                            tooltip: "toolTipClass",
                          }}
                          placement="bottom-start"
                        >
                          <div className="expiredContentnew">
                            <span>Expired</span>
                          </div>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                      {/* showTickMarkByIndex[`${index}-${subIndex}`]  */}
                      {/* {showTickMarkByIndex[index] && (
                        <img
                          src={claimChecked}
                          className={
                            item?.mlrStatus === "Expired"
                              ? "img-fluid claimsChecked expiredClaimsChecked"
                              : "img-fluid claimsChecked "
                          }
                        ></img>
                      )} */}
                      {item?.mlrStatus !== "Expired" &&
                        showTickMarkByIndex[index] && (
                          <img
                            src={claimChecked}
                            className="img-fluid claimsChecked"
                            alt=""
                          />
                        )}
                    </div>

                    {item?.relatedClaims?.length > 0 &&
                      item?.mlrStatus !== "Expired" &&
                      expand && (
                        <div style={{ marginLeft: "27px", marginTop: "6px" }}>
                          <p className="relatedClaimsText">
                            Related Claims
                            <span> ({item?.relatedClaims?.length})</span>
                          </p>
                          {item?.relatedClaims?.length > 0 &&
                            item?.relatedClaims?.map((subItem, subIndex) => {
                              const isSelectedItem =
                                selectedRelatedClaimIndex?.module === index &&
                                selectedRelatedClaimIndex?.sub === subIndex;
                              return (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      if (subItem?.mlrStatus === "Expired")
                                        return;
                                      // Select exactly this one; others are implicitly deselected
                                      setSelectedRelatedClaimIndex({
                                        module: index,
                                        sub: subIndex,
                                      });
                                      setSelectedClaimIndex(null);
                                      setIsFootnoteSelected(0);
                                      setFootnoteClicked({
                                        ...footnoteClicked,
                                        index: null,
                                      });
                                    }}
                                    className={
                                      isSelectedItem
                                        ? "itemSectionActive"
                                        : "itemSectionInactive"
                                    }
                                  >
                                    <Tooltip
                                      title={
                                        subItem?.mlrStatus !== "Expired"
                                          ? "Available for Use"
                                          : "Expired"
                                      }
                                      arrow
                                      classes={{
                                        popper: "toolTipClass2",
                                        tooltip: "toolTipClass2",
                                      }}
                                      placement="bottom-start"
                                    >
                                      <span>
                                        <img
                                          src={
                                            subItem?.mlrStatus !== "Expired"
                                              ? available
                                              : expiredStatus
                                          }
                                          className="img-fluid expiryIcon"
                                          alt=""
                                        />
                                      </span>
                                    </Tooltip>
                                    {subItem.claimName ||
                                      subItem?.componentDocNumber}
                                    <div>
                                      <div
                                        className="parentModulebox"
                                        style={{
                                          backgroundColor: item.mustUse
                                            ? "#E32B35"
                                            : "#378A05",
                                          marginLeft: "10px",
                                          marginRight: "3px",
                                        }}
                                      ></div>
                                    </div>
                                    {subItem?.mlrStatus === "Expired" ? (
                                      <Tooltip
                                        title="Related Claim is expired, can't be used for authoring"
                                        arrow
                                        classes={{
                                          popper: "toolTipClass",
                                          tooltip: "toolTipClass",
                                        }}
                                        placement="bottom-start"
                                      >
                                        <div className="expiredContentnew">
                                          <span>Expired</span>
                                        </div>
                                      </Tooltip>
                                    ) : (
                                      ""
                                    )}
                                    {showTickMarkByIndex[
                                      `${index}-${subIndex}`
                                    ] && (
                                      <img
                                        src={claimChecked}
                                        className={
                                          subItem?.mlrStatus === "Expired"
                                            ? "img-fluid claimsChecked expiredClaimsChecked "
                                            : "img-fluid claimsChecked relatedClaimsChecked"
                                        }
                                      ></img>
                                    )}
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row moduleTextFootnoteRow">
            {selctedModuleData && (
              <>
                {" "}
                <div
                  className={
                    selctedModuleData?.subType === "Data Graphic" &&
                    selectedClaimIndex != null &&
                    selectedRelatedClaimIndex?.module == null
                      ? "newMatchtextSectionNoborder customScrollBar"
                      : "newMatchtextSection customScrollBar"
                  }
                >
                  {selctedModuleData?.subType === "Data Graphic" ? (
                    <>
                      <div className="topics2">Image</div>
                      <img
                        src={selctedModuleData?.componentUrl}
                        alt=""
                        className="img-fluid sixdotIcon"
                        style={{
                          width: "100%",
                          cursor: "move",
                          padding: "5px",
                          backgroundColor: "rgb(255, 255, 255)",
                          boxShadow: "none",
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <p className="topics2">
                        Match Text
                        {(() => {
                          const symbol = getSymbol(
                            selctedModuleData?.matchText?.endsWith(".")
                              ? selctedModuleData?.matchText
                              : selctedModuleData?.matchText + "."
                          );
                          return (
                            symbol &&
                            symbol !== "Not Assigned" && (
                              <>
                                <span className="symbolLine"></span>
                                <span style={{ marginLeft: "7px" }}>
                                  {symbol}
                                </span>
                              </>
                            )
                          );
                        })()}
                      </p>
                      <div className="contentText">
                        {selctedModuleData?.matchText}
                      </div>
                    </>
                  )}
                  <>
                    {selctedModuleData?.matchTextVariants?.map(
                      (item, index) => {
                        return (
                          <>
                            <div
                              className="topics2"
                              style={{ marginTop: "12px" }}
                            >
                              {`Match Text Variant ${index + 1}`}{" "}
                            </div>
                            <div
                              style={{ marginTop: "0px" }}
                              className="contentText"
                            >
                              <div>{item?.matchText}</div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </>

                  {selctedModuleData?.footnotes?.length > 0 && (
                    <>
                      {selctedModuleData.footnotes
                        .split(/(?<=\.)\s*,\s*/g)
                        .map((note, i) => {
                          const isParent =
                            selectedRelatedClaimIndex.module === null;
                          const isSelectedFootnote =
                            footnoteClicked.module ===
                              (isParent
                                ? selectedClaimIndex
                                : selectedRelatedClaimIndex?.module) &&
                            footnoteClicked.sub ===
                              (isParent
                                ? null
                                : selectedRelatedClaimIndex?.sub) &&
                            footnoteClicked.index === i;
                          return (
                            <div
                              key={i}
                              style={{ marginBottom: "4px", marginTop: "12px" }}
                              onClick={() => {
                                setFootnoteClicked({
                                  module: isParent
                                    ? selectedClaimIndex
                                    : selectedRelatedClaimIndex?.module,
                                  sub: isParent
                                    ? null
                                    : selectedRelatedClaimIndex?.sub,
                                  index: i,
                                });
                                setSymbolsByIndex(note.trim());
                                setIsFootnoteSelected(0);
                              }}
                              className={
                                isSelectedFootnote
                                  ? "footnoteClick footnoteWithoutlick"
                                  : "footnoteWithoutlick"
                              }
                            >
                              <div
                                style={{ whitespace: "nowrap" }}
                                className="topics2  contentText"
                              >
                                Footnotes
                                {getSymbol(
                                  note.trim().endsWith(".")
                                    ? note.trim()
                                    : note.trim() + "."
                                ) &&
                                  getSymbol(
                                    note.trim().endsWith(".")
                                      ? note.trim()
                                      : note.trim() + "."
                                  ) !== "Not Assigned" && (
                                    <>
                                      <span className="symbolLine"></span>
                                      <span style={{ marginLeft: "7px" }}>
                                        {getSymbol(
                                          note.trim().endsWith(".")
                                            ? note.trim()
                                            : note.trim() + "."
                                        )}
                                      </span>
                                    </>
                                  )}
                              </div>{" "}
                              <span>
                                {note.trim().endsWith(".")
                                  ? note.trim()
                                  : note.trim() + "."}
                                {note.trim().endsWith(".") ? "" : "."}
                              </span>
                            </div>
                          );
                        })}
                    </>
                  )}

                  {selctedModuleData?.abbreviation?.length > 0 && (
                    <div className="topics2" style={{ marginTop: "12px" }}>
                      Abbreviations
                    </div>
                  )}

                  <div className="contentText">
                    {" "}
                    {selctedModuleData?.abbreviation}
                  </div>
                  {/* </> */}
                  {/* );
              })} */}
                  {selctedModuleData?.references?.length > 0 && (
                    <div className="topics2" style={{ marginTop: "12px" }}>
                      References
                    </div>
                  )}
                  {selctedModuleData?.references?.map((item, index) => {
                    return (
                      <>
                        <div className="contentText">
                          <span> {`${index + 1}. ${item.documentName}`}</span>
                        </div>
                      </>
                    );
                  })}
                </div>
              </>
            )}
            {/* </div> */}
            {selctedModuleData?.subType !== "Data Graphic" && (
              <div className="footnoteandClaim">
                <div
                  className={
                    selectedRelatedClaimIndex?.sub === null
                      ? "noclaimSymbol d-flex "
                      : "baseOnModalHeadingfootnotenew d-flex"
                  }
                >
                  <div
                    className="section-changeFootnote"
                    style={{
                      borderBottom:
                        isFootnoteSelected === 0 ? "2px solid #203662" : "",
                      color: isFootnoteSelected === 0 ? "#203662" : "#1E1E1E",
                      marginLeft: "20px",
                      fontWeight: isFootnoteSelected === 0 ? "600" : "400",
                    }}
                    onClick={() => setIsFootnoteSelected(0)}
                  >
                    Assign Footnote Symbol
                  </div>
                  {selectedRelatedClaimIndex?.sub != null &&
                    !component?.componentId && (
                      <div
                        className="section-changeFootnote"
                        style={{
                          borderBottom:
                            isFootnoteSelected === 1 ? "2px solid #203662" : "",
                          color:
                            isFootnoteSelected === 1 ? "#203662" : "#1E1E1E",
                          marginLeft: "30px",
                          fontWeight: isFootnoteSelected === 1 ? "600" : "400",
                        }}
                        onClick={() => {
                          setIsFootnoteSelected(1);
                        }}
                      >
                        Assign Claim Symbol
                      </div>
                    )}
                </div>

                <div className="footnoteSymbolContainer customScrollBar">
                  {footnoteSymbols.map((symbol, index) => {
                    return (
                      <div
                        key={index}
                        onClick={
                          !(
                            footnoteClicked.index !== null ||
                            isFootnoteSelected === 1
                          )
                            ? () => {}
                            : allUsedSymbols.includes(symbol) ||
                              (selectedSymbol || currentSymbol) === symbol
                            ? () => {}
                            : () =>
                                handleSymbolClick(
                                  symbol,
                                  symbolsByIndex,
                                  selectedRelatedClaimIndex?.module ??
                                    selectedClaimIndex,
                                  selectedRelatedClaimIndex?.sub ?? null
                                )
                        }
                        onMouseEnter={
                          allUsedSymbols.includes(symbol)
                            ? () => {}
                            : () => handleMouseEnter(symbol)
                        }
                        onMouseLeave={handleMouseLeave}
                        className={`symbolBox  ${
                          (selectedSymbol || currentSymbol) === symbol
                            ? "selected"
                            : ""
                        }`}
                        style={{
                          paddingTop:
                            index === 15 || index === 16
                              ? "14px"
                              : index === 32
                              ? "7px"
                              : index === 1
                              ? "8px"
                              : index === 0
                              ? "24px"
                              : "0px",
                          width: "77px",
                          height: "77px",
                          color: allUsedSymbols.includes(symbol)
                            ? "#A9AAAC"
                            : (selectedSymbol || currentSymbol) === symbol
                            ? "#203662"
                            : hoveredSymbol === symbol
                            ? "#000000"
                            : "#1E1E1E",
                          borderRadius: "6px",
                          border: allUsedSymbols.includes(symbol)
                            ? "none"
                            : "1px solid #D1E6E6",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: !(
                            footnoteClicked.index !== null ||
                            isFootnoteSelected === 1
                          )
                            ? "not-allowed"
                            : allUsedSymbols.includes(symbol)
                            ? "not-allowed"
                            : "pointer",
                          fontSize:
                            symbol === "***" || symbol === "**"
                              ? "28px"
                              : symbol === "†"
                              ? "40px"
                              : symbol === "*"
                              ? "52px"
                              : symbol === "††"
                              ? "40px"
                              : "28px",
                          fontWeight:
                            symbol === "△" ||
                            symbol === "~" ||
                            symbol === "ǂ" ||
                            symbol === "£" ||
                            symbol === "‡‡"
                              ? "700"
                              : "500",
                          letterSpacing: symbol === "∥∥" && "-1.9px",
                          fontFamily: [
                            "I",
                            "II",
                            "III",
                            "IV",
                            "V",
                            "VI",
                            "VII",
                            "VIII",
                            "IX",
                            "X",
                          ].includes(symbol)
                            ? `"Times New Roman', serif"`
                            : `"Nunito Sans", sans-serif`,
                          backgroundColor: allUsedSymbols.includes(symbol)
                            ? "#F2F3F3"
                            : (selectedSymbol || currentSymbol) === symbol
                            ? "#D1E6E6"
                            : hoveredSymbol === symbol &&
                              (footnoteClicked.index !== null ||
                                isFootnoteSelected === 1)
                            ? "#d1e6e6"
                            : !(
                                footnoteClicked.index !== null ||
                                isFootnoteSelected === 1
                              )
                            ? "transparent"
                            : "transparent",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {symbol}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
      <DialogActions
        className="infoSDialog"
        style={{
          height: "60px",
          boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.0824)",
        }}
      >
        <div className="footerActions">
          <Button
            className="closeButtn"
            onClick={() => {
              handleCloseQualifiersModal(true, textSymblMapTemp);
              setSelectedClaimIndex(0);
            }}
          >
            CANCEL
          </Button>
          <Button
            style={{ height: "32px", width: "88px" }}
            disabled={!allSymbolsAssigned}
            className={
              allSymbolsAssigned
                ? "updateButtonSymbol2"
                : "disbledUpdateSymbol2"
            }
            onClick={() => {
              assignSymbolsToAllModules();
            }}
          >
            ASSIGN
          </Button>
        </div>
        <Divider className="DialogFooterLine"></Divider>
      </DialogActions>
    </Dialog>
  );
}
